import {
  collection,
  query,
  where,
  getDocs,
  setDoc,
  doc,
  updateDoc, // Certifique-se de importar updateDoc
  Timestamp,
} from 'firebase/firestore';
import { db } from '../firebase';

// Função para buscar clínicas associadas a um usuário
export const getClinicas = async (userId) => {
  try {
    const q = query(collection(db, 'clinicas'), where('userId', '==', userId));
    const querySnapshot = await getDocs(q);
    return querySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
  } catch (error) {
    console.error('Erro ao buscar clínicas:', error);
    throw new Error('Erro ao buscar clínicas: ' + error.message);
  }
};

// Função para buscar pacientes associados a um usuário
export const getPacientes = async (userId) => {
  try {
    const q = query(collection(db, 'pacientes'), where('userId', '==', userId));
    const querySnapshot = await getDocs(q);
    return querySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
  } catch (error) {
    console.error('Erro ao buscar pacientes:', error);
    throw new Error('Erro ao buscar pacientes: ' + error.message);
  }
};

// Função para buscar atendimentos associados a um usuário
export const getAtendimentos = async (userId) => {
  try {
    const q = query(
      collection(db, 'atendimentos'),
      where('userId', '==', userId)
    );
    const querySnapshot = await getDocs(q);
    return querySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
  } catch (error) {
    console.error('Erro ao buscar atendimentos:', error);
    throw new Error('Erro ao buscar atendimentos: ' + error.message);
  }
};

// Função para criar um novo atendimento
export const createAtendimento = async (atendimentoData) => {
  try {
    // Verificar se o atendimento já existe com base no nome e data de atendimento
    const q = query(
      collection(db, 'atendimentos'),
      where('nomePaciente', '==', atendimentoData.nomePaciente),
      where('dataAtendimento', '==', atendimentoData.dataAtendimento)
    );
    const querySnapshot = await getDocs(q);

    if (!querySnapshot.empty) {
      throw new Error(
        'Atendimento já registrado para este paciente nesta data.'
      );
    }

    const newAtendimentoRef = doc(collection(db, 'atendimentos'));
    await setDoc(newAtendimentoRef, {
      ...atendimentoData,
      dataCriacao: Timestamp.now(), // Usando o Timestamp do Firebase
    });
    return { id: newAtendimentoRef.id, ...atendimentoData };
  } catch (error) {
    console.error('Erro ao registrar atendimento:', error);
    throw new Error('Erro ao registrar atendimento: ' + error.message);
  }
};

// Função para atualizar as observações de um paciente existente
export const updatePacienteObservacao = async (pacienteId, observacao) => {
  try {
    const pacienteRef = doc(db, 'pacientes', pacienteId);
    await updateDoc(pacienteRef, { observacoes: observacao });
  } catch (error) {
    console.error('Erro ao atualizar observação do paciente:', error);
    throw new Error(
      'Erro ao atualizar observação do paciente: ' + error.message
    );
  }
};

// Função para criar ou atualizar paciente (novo ou existente)
export const createPaciente = async (pacienteData) => {
  try {
    // Checar se o paciente já existe com base no nome e userId
    const q = query(
      collection(db, 'pacientes'),
      where('nome', '==', pacienteData.nome),
      where('userId', '==', pacienteData.userId)
    );
    const querySnapshot = await getDocs(q);

    if (!querySnapshot.empty) {
      // Paciente já existe, atualizar dados
      const pacienteDoc = querySnapshot.docs[0];
      await updateDoc(doc(db, 'pacientes', pacienteDoc.id), {
        ...pacienteData,
        dataAtualizacao: Timestamp.now(),
      });
      return { id: pacienteDoc.id, ...pacienteData, atualizado: true };
    } else {
      // Criar novo paciente
      const newPacienteRef = doc(collection(db, 'pacientes'));
      await setDoc(newPacienteRef, {
        ...pacienteData,
        dataCadastro: Timestamp.now(),
      });
      return { id: newPacienteRef.id, ...pacienteData };
    }
  } catch (error) {
    console.error('Erro ao registrar ou atualizar paciente:', error);
    throw new Error(
      'Erro ao registrar ou atualizar paciente: ' + error.message
    );
  }
};
